import type { ReactNode } from 'react';
import Menu, { MenuItem, MenuDivider, type MenuProps } from '@/components/Menu';
import { DeleteIcon, EditIcon } from '@/icons';

export { MenuDivider };

export type DefaultOptionsMenuProps = {
  open: boolean;
  closeOnSelect?: boolean;
  separateDelete?: boolean;
  className?: string;
  anchorTo: HTMLElement | null;
  anchorOrigin?: MenuProps['anchorOrigin'];
  transformOrigin?: MenuProps['transformOrigin'];
  extraOptions?: ReactNode;
  onEdit?: () => void;
  onDelete: () => void;
  onClose: () => void;
};

export default function DefaultOptionsMenu({
  open,
  closeOnSelect = true,
  separateDelete,
  className,
  anchorTo,
  anchorOrigin,
  transformOrigin,
  extraOptions,
  onEdit,
  onDelete,
  onClose,
}: DefaultOptionsMenuProps) {
  const handleEdit = () => {
    onEdit?.();
    if (closeOnSelect) onClose();
  };

  const handleDelete = () => {
    onDelete();
    if (closeOnSelect) onClose();
  };

  return (
    <Menu
      anchorTo={anchorTo}
      open={open}
      className={className}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      onClose={onClose}>
      {extraOptions}
      {onEdit && (
        <MenuItem
          label="Edit"
          icon={<EditIcon fontSize="small" />}
          onClick={handleEdit}
        />
      )}
      {separateDelete && <MenuDivider />}
      <MenuItem
        destructive
        label="Delete"
        icon={<DeleteIcon fontSize="small" />}
        onClick={handleDelete}
      />
    </Menu>
  );
}
